import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppState, Store, Observable, AppFields, ClubProgram, filter, map, ProgramsBillingType, ProgramsBaseUrl } from '../../../store';

@Component({
  selector: 'app-page-header-breadcrumb',
  templateUrl: './page-header-breadcrumb.component.html',
  styleUrls: ['./page-header-breadcrumb.component.css']
})
export class PageHeaderBreadcrumbComponent implements OnInit {

  currentPage: Observable<string>;
  programsLink: Observable<string>;
  program: Observable<ClubProgram>;
  billingType: Observable<string>;

  constructor(
    private router: Router,
    private store: Store<AppState>
  ) {
    this.program = this.store.select(AppFields.App, AppFields.Program);
  }

  ngOnInit() {
    this.currentPage = this.program.pipe(filter(p => !!p), map((p: ClubProgram) => {
      const routes = [
        { url: `/programs/add`, title: 'New Program' },
        { url: `/programs/${p.clubprogramID}/setup`, title: 'Edit Program' },
        { url: `/programs/${p.clubprogramID}/banking`, title: 'Banking' },
        { url: `/programs/${p.clubprogramID}/reports`, title: 'Report' },
        { url: `/programs/${p.clubprogramID}/discount`, title: 'Discount' },
        { url: `/programs/${p.clubprogramID}/messages`, title: 'Message' },
        { url: `/programs/${p.clubprogramID}/question`, title: 'Question' },
        { url: `/programs/${p.clubprogramID}/formagreement`, title: 'Forms / Agreement' },
        { url: `/programs/${p.clubprogramID}/members`, title: 'DASHBOARD' },
        { url: `/programs/${p.clubprogramID}/fees`, title: 'Fees' }
      ];
      const page = routes.find(r => this.router.url.includes(r.url));
      return page ? page.title : '';
    }));

    this.programsLink = this.program.pipe(filter(p => !!p), map((p: ClubProgram) => {
      return (ProgramsBaseUrl[p.clubProgramTypeID] || '') + '/programs/active';
    }));

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/page-header-breadcrumb/page-header-breadcrumb.component.ts